module.exports = __webpack_public_path__ + "img/swiper5.f3e17c4d.jpg";